<template>
  <section class="content">
    <!-- Default box -->
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">{{head_name}}</h3>

        <!-- <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
            <i class="fa fa-minus"></i></button>
          <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
            <i class="fa fa-times"></i></button>
        </div> -->
      </div>
      <div class="box-body" style="height: 100%;min-height: 700px;">
        <div class="tc" style="padding-top: 20%;font-weight:700;">
          <img src="../../assets/img/empty_page.svg" alt="Product Image" style="width: 200px;">
            <br>
          <span style="font-size: 12px;">We'll update shortly</span>
          <!-- <p style="font-size: 11px;color: gray;">"We'll notify your once we have something for you"</p> -->
        </div>
      </div>
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
  </section>
</template>

<script>
export default {
  name: 'tabs-card',
  data () {
    return {
      head_name: ''
    }
  },
  created () {
    this.head_name = this.$route.name
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
</style>>
